export default __webpack_public_path__ + "static/media/ic11.e0f8d831.gif";